import React, { FC, memo, useState, useCallback } from "react";
import styled from "@emotion/styled";
import { Input } from "antd";
import { CloseOutlined } from "src/icons";

const ClearableSearchInput = styled.section`
  position: relative;
  width: 100%;
  .clearBtn {
    position: absolute;
    right: 1.1rem;
    font-size: 1.4rem;
    top: 10px;
  }
  .ant-input {
    background: transparent !important;
    color: white !important;
    height: 40px !important;
    border-color: rgba(255, 255, 255, 0.25) !important;
  }
  .ant-input:focus {
    border-color: rgba(255, 255, 255, 0.25) !important;
  }
`;

const SearchInputBox: FC<{
  onChange: (searchText: string) => void;
  className?: string;
}> = ({ onChange, className }) => {
  const [searchText, setSearchText] = useState("");
  const onClearSearch = useCallback(() => {
    setSearchText("");
    onChange("");
  }, []);

  const onSearchChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const {
      target: { value },
    } = e;
    setSearchText(value);
    onChange(value);
  }, []);

  return (
    <ClearableSearchInput className={className}>
      <Input placeholder="Type a city or area" onChange={onSearchChange} value={searchText} />
      {searchText && <CloseOutlined className="clearBtn" onClick={onClearSearch} />}
    </ClearableSearchInput>
  );
};

export default memo(SearchInputBox);
